import { AbiItem } from 'web3-utils'
import contractABI from './contract-abi.json'
import { createAlchemyWeb3 } from '@alch/alchemy-web3'

const web3 = createAlchemyWeb3(process.env.REACT_APP_ALCHEMY_KEY as string)

const CONTRACT_ADDR =
  process.env.NODE_ENV === 'development'
    ? '0x95161ee867aa998686af113869a63ca8455aacad'
    : '0x59c8d90D0693E336E7ece120eE8dFA4770105cBC'

export enum WalletStatus {
  WALLET_FOUND,
  WALLET_ERROR,
  METAMASK_FOR_DUMMIES,
  INSTALL_METAMASK,
  MINT_SUCCESS,
  MINT_ERROR,
}

export interface Wallet {
  address: string
  status?: WalletStatus
}

export const getCurrentWalletConnected = async () => {
  if ((window as any).ethereum) {
    try {
      const addressArray = await (window as any).ethereum.request({
        method: 'eth_accounts',
      })
      if (addressArray.length) {
        const contract = new web3.eth.Contract(contractABI as AbiItem[], CONTRACT_ADDR)
        const totalSupply: number = await contract.methods.totalSupply().call()
        return {
          address: addressArray[0],
          status: WalletStatus.WALLET_FOUND,
          supply: totalSupply,
        }
      }
      return {
        address: '',
        status: WalletStatus.METAMASK_FOR_DUMMIES,
      }
    } catch (err) {
      return {
        address: '',
        error: (err as any).message,
        status: WalletStatus.WALLET_ERROR,
      }
    }
  } else {
    return {
      address: '',
      status: WalletStatus.INSTALL_METAMASK,
    }
  }
}

export const mintNFT = async (quantity: number) => {
  const accounts = await (window as any).ethereum.request({
    method: 'eth_requestAccounts',
  })

  ;(window as any).contract = await new web3.eth.Contract(contractABI as AbiItem[], CONTRACT_ADDR)
  let response

  try {
    response = await (window as any).contract.methods.mainMint(quantity).send({
      to: CONTRACT_ADDR,
      value: 200000000000000000 * quantity,
      // value: 40000 * quantity,
      from: accounts[0],
    })

    return {
      status: WalletStatus.MINT_SUCCESS,
      transactionUrl: 'https://etherscan.io/tx/' + response.transactionHash,
    }
  } catch (error) {
    return {
      status: WalletStatus.MINT_ERROR,
    }
  }
}
